import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ModalBody, Spinner } from 'reactstrap'

import * as checklistActions from 'store/Checklist/actions'
import ChecklistModal from './components/ChecklistModal'
import Footer from './components/Footer'
import FooterExtended from './components/FooterExtended'
import ChecklistHeader from './components/ChecklistHeader'
import Table from './components/Table'

import './style.css'
import Loader from '../Loader'

const Checklist = (props) => {
  const language = useSelector((state) => state.language?.language?.data)
  const search = `${props.location.search}&user_id=${props.match.params.userId}`
  const currentChecklist = useSelector((state) => state.checklist)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(checklistActions.getChecklist(search))
  }, [search, dispatch])
  return (
    <ChecklistModal
      courseId={props.course_id}
      userId={props.userId}
      title={language.manager_report ? language.manager_report.checklist : null}
      size='xl'
    >
      {currentChecklist.loaded ? (
        <ModalBody className='scrollbar'>
          {currentChecklist.sections.length ? (
            <ChecklistHeader {...props} {...currentChecklist} />
          ) : null}
          {currentChecklist.sections.length ? (
            <Table {...props} checklist={currentChecklist} />
          ) : null}

          {currentChecklist.status !== 'submit' ? (
            <Footer {...props} {...currentChecklist} />
          ) : currentChecklist.waitingForApproval === true ? (
            currentChecklist.approvalPrivilege ? (
              <FooterExtended {...props} {...currentChecklist} />
            ) : (
              <div className='row'>
                <div className='col-12'>
                  <p className='second-approval-message m-r-20'>
                    {language.manager_report
                      ? language.manager_report.waiting_second_level_approval
                      : null}
                  </p>
                </div>
              </div>
            )
          ) : null}
        </ModalBody>
      ) : (
        <div className='d-flex justify-content-center align-items-center h-100'>
          {/* <Spinner /> */}
          <Loader />
        </div>
      )}
    </ChecklistModal>
  )
}

export default Checklist
